import { createExtension } from "@/modules/work/jobs/extensions/create/api";
import { invalidateAllJobExtensionQueries } from "@/modules/work/jobs/extensions/queries";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { formatDateForAPI } from "utils/utils";

function buildPayload(values) {
  return{
    ...values,
    end_date: formatDateForAPI(values.end_date),
  }
}

export const useCreateExtension = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      const payload = buildPayload(values);
      const response = await createExtension({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Extension Created Successfully");
      invalidateAllJobExtensionQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
};
